<script setup>
import { computed } from 'vue';
import { product } from '../state';

const catalog = computed(() => product.value.catalogs.length ? product.value.catalogs[0] : {})
const defaultUnit = computed(() => {
  const unitByInventory = (product.value.inventory_unit || []).find(i => i.numerator === 1 && i.denumerator === 1)

  return unitByInventory?.unit || catalog.value.uom || catalog.value.price?.uom || ''
})
</script>

<template>
  <a-row>
    <a-col class="mb-3" :span="6">
      <div class="title-detail d-flex justify-content-start mb-2">
        {{ $t('product.physical_product') }}
      </div>
    </a-col>
    <a-col class="mb-4" :span="18">
      <div class="text-left mb-2">
        : {{ product.details.is_physical ? $t('utils.yes') : $t('utils.no') }}
      </div>
    </a-col>
    <div v-if="product.details.is_physical">
      <a-col class="mb-2" :span="24">
        <div class="font-weight-semibold d-flex justify-content-start mb-2">
          {{ $t('product.base_unit') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.product_unit') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="18">
        <div class="text-left mb-2">
          : {{ defaultUnit }}
        </div>
      </a-col>
      <a-col class="mb-4" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.weight') }}
        </div>
      </a-col>
      <a-col class="mb-4" :span="18">
        <div class="text-left mb-2">
          : {{ catalog.weight }} <span>gram</span>
        </div>
      </a-col>
      <a-col class="mb-2" :span="24">
        <div class="font-weight-semibold d-flex justify-content-start mb-2">
          {{ $t('product.package_size') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.width') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="18">
        <div class="text-left mb-2">
          : {{ catalog.width }} mm
        </div>
      </a-col>
      <a-col class="mb-2" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.length') }}
        </div>
      </a-col>
      <a-col class="mb-2" :span="18">
        <div class="text-left mb-2">
          : {{ catalog.length }} mm
        </div>
      </a-col>
      <a-col class="mb-3" :span="6">
        <div class="title-detail d-flex justify-content-start mb-2">
          {{ $t('product.height') }}
        </div>
      </a-col>
      <a-col class="mb-3" :span="18">
        <div class="text-left mb-2">
          : {{ catalog.height }} mm
        </div>
      </a-col>
    </div>
  </a-row>
</template>
